import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // Check if user is properly authenticated with both token and user data
    if (this.authService.isAuthenticated()) {
      const userData = this.authService.getUserData();
      
      // Additional validation: ensure we have valid user data with role
      if (userData && userData.code_role) {
        return true;
      }
    }
    
    // If authentication fails, clear any invalid session data and redirect
    this.authService.logout();
    
    // Use createUrlTree for better routing performance
    return this.router.createUrlTree(['/auth/login']);
  }
}